import { InretrnWidgetContent } from "./inreturn-widget-content";
import { getInreturnCredentials } from "../../../utils/get-inreturn-credentials";

const { inretrnUrl, inretrnToken } = getInreturnCredentials();
const returnType = "withdrawal";

export const InretrnWithdrawWidget = () => {
  return (
    <InretrnWidgetContent
      scriptUrl={inretrnUrl}
      token={inretrnToken}
      returnType={returnType}
    />
  );
};
